import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.orderTransaction.replace(appPath.orderDetail, ''),
	components: () => [import(/* webpackChunkName: 'orderTransaction' */ './component')],
	render: ([OrderTransaction]) => <OrderTransaction />,
};

export default routes;
